module.exports = __webpack_public_path__ + "static/img/makinde.56c19de.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/members/makinde.jpg
// module id = oAHz
// module chunks = 1